(function () {
    'use strict';

    angular
        .module('salesflare')
        .service('plansService', plansService);

    function plansService(model, $translate) {

        this.currency = '$';

        if (model.me.team.billing_currency && model.me.team.billing_currency.html === '&#128;') {
            this.currency = '€';
        }

        const plans = {
            growth: {
                id: 3,
                name: 'Growth',
                price: {
                    annually: {
                        pricePerBillingCycle: 348,
                        pricePerMonth: 29
                    },
                    monthly: {
                        pricePerBillingCycle: 39,
                        pricePerMonth: 39
                    }
                },
                featureSummary: $translate.instant('All CRM features you\'d expect, plus'),
                features: [
                    {
                        // Flag: 'enrichContacts',
                        name: $translate.instant('Automate your CRM data input'),
                        description: $translate.instant('Salesflare will automatically gather contact and company info from emails, email signatures, social profiles, and more. It will also log your meetings and phone calls for you.'),
                        image: 'images/features/enrich_contacts.png',
                        plan: 'Growth'
                    },
                    {
                        // Flag: 'customFields',
                        name: $translate.instant('Track emails, links and website visits'),
                        description: $translate.instant('Track when and how your customers are digitally engaging with you. Invaluable tracking information is stored per customer and is revealed to you as real-time notifications, so you can follow up in an informed way.'),
                        image: 'images/features/custom_fields.png',
                        plan: 'Growth'
                    },
                    {
                        // Flag: 'maxPipelines',
                        name: $translate.instant('Get a LinkedIn sidebar, email sidebar & mobile app'),
                        description: $translate.instant('Salesflare works right in LinkedIn as well as your Gmail or Outlook inbox, and has a mobile app for iOS and Android too. All of this without losing any desktop features.'),
                        image: 'images/features/multiple_pipelines.png',
                        plan: 'Growth'
                    },
                    {
                        // Flag: 'crossEntityFiltering',
                        name: $translate.instant('Send personalized email campaigns'),
                        description: $translate.instant('Send personalized emails from any mailbox connected to Salesflare. Choose until when your email should send. And track the responses.'),
                        image: 'images/features/advanced_filtering.png',
                        plan: 'Growth'
                    },
                    {
                        // Flag: 'findEmail',
                        name: $translate.instant('5 lead credits'),
                        description: $translate.instant('Find leads from within Salesflare and LinkedIn. Additional monthly lead credits can be bought in Settings > Billing: 250 for {{currency}}39/{{currency}}49, 500 for {{currency}}69/{{currency}}79, or 1000 for {{currency}}129/{{currency}}139 (billed annually/monthly).', { currency: this.currency }),
                        image: 'images/features/find_email.png',
                        plan: 'Growth'
                    }
                ]
            },
            pro: {
                id: 4,
                name: 'Pro',
                price: {
                    annually: {
                        pricePerBillingCycle: 588,
                        pricePerMonth: 49
                    },
                    monthly: {
                        pricePerBillingCycle: 64,
                        pricePerMonth: 64
                    }
                },
                featureSummary: $translate.instant('All features on the Growth plan, plus'),
                features: [
                    {
                        flag: 'multiStepWorkflows',
                        name: $translate.instant('Send workflows of multiple emails'),
                        description: $translate.instant('Follow up beyond the first mass or automated email. Send personalized email flows from any mailbox connected to Salesflare. And track the responses.'),
                        downgradeDescription: $translate.instant('You will lose the ability to send workflows with multiple steps. The ones currently active will be paused.'),
                        image: 'images/features/email-workflows-multi-step.png',
                        plan: 'Pro'
                    },
                    {
                        flag: 'permissions',
                        name: $translate.instant('Set user permissions'),
                        description: $translate.instant('Take control of your team\'s data. Restrict what your team can see, edit or delete. Give them access to specific pipelines only. Create view-only users. And assign managers to user groups.'),
                        downgradeDescription: $translate.instant('Your permission settings will be reset to the default. All your colleagues will get unrestricted access to all data and pipelines.'),
                        image: 'images/features/permissions.png',
                        plan: 'Pro'
                    },
                    {
                        flag: 'customDashboards',
                        name: $translate.instant('Create custom dashboards '),
                        description: $translate.instant('Customize your Insights dashboards and learn from your data. Add custom reports, re-order them in the dashboard, and even create new dashboards.'),
                        downgradeDescription: $translate.instant('You won\'t be able to see your custom reports or customize your Insights dashboards anymore. If you decide to upgrade again, you will regain access to your custom reports.'),
                        image: 'images/features/custom_insights.jpg',
                        plan: 'Pro'
                    },
                    {
                        // Flag: 'findEmail',
                        name: $translate.instant('100 lead credits'),
                        description: $translate.instant('Find leads from within Salesflare and LinkedIn. Additional monthly lead credits can be bought in Settings > Billing: 250 for {{currency}}39/{{currency}}49, 500 for {{currency}}69/{{currency}}79, or 1000 for {{currency}}129/{{currency}}139 (billed annually/monthly).', { currency: this.currency }),
                        image: 'images/features/find_email.png',
                        plan: 'Pro'
                    }
                ]
            },
            enterprise: {
                id: 5,
                name: 'Enterprise',
                price: {
                    annually: {
                        pricePerBillingCycle: 1188,
                        pricePerMonth: 99
                    },
                    monthly: {
                        pricePerBillingCycle: 1488,
                        pricePerMonth: 124
                    }
                },
                featureSummary: $translate.instant('All features on the Pro plan, plus'),
                features: [
                    {
                        // Flag: 'multiStepWorkflows',
                        name: $translate.instant('Custom training'),
                        description: $translate.instant('Get training that is customized for your team so you can get the most out of Salesflare in no time.'),
                        downgradeDescription: $translate.instant('You can still access our self-service how-to videos and articles from the question mark in the main Salesflare menu.'),
                        image: 'images/features/email_campaigns.png',
                        plan: 'Pro'
                    },
                    {
                        // Flag: 'permissions',
                        name: $translate.instant('Data migration done for you'),
                        description: $translate.instant('We\'ll take care of importing your current data into Salesflare for you, so you don\'t have to worry about it.'),
                        downgradeDescription: $translate.instant('You can still take care of any data migration yourself via the \'Import data\' tab in the settings menu.'),
                        image: 'images/features/website_tracking.png',
                        plan: 'Pro'
                    },
                    {
                        // Flag: 'customDashboards',
                        name: $translate.instant('Dedicated account manager'),
                        description: $translate.instant('Get a single point of contact at Salesflare who follows up on your personal needs and questions.'),
                        downgradeDescription: $translate.instant('You can still request general support via Intercom chat or by emailing support@salesflare.com'),
                        image: 'images/features/hotness.png',
                        plan: 'Pro'
                    },
                    {
                        // Flag: 'findEmail',
                        name: $translate.instant('250 lead credits'),
                        description: $translate.instant('Find leads from within Salesflare and LinkedIn. Additional monthly lead credits can be bought in Settings > Billing: 250 for {{currency}}39/{{currency}}49, 500 for {{currency}}69/{{currency}}79, or 1000 for {{currency}}129/{{currency}}139 (billed annually/monthly).', { currency: this.currency }),
                        image: 'images/features/find_email.png',
                        plan: 'Pro'
                    }
                ]
            }
        };

        const creditPlans = {
            small: {
                name: 'Small',
                size: 'S',
                amount: 250,
                price: {
                    annually: {
                        pricePerBillingCycle: 468,
                        pricePerMonth: 39
                    },
                    monthly: {
                        pricePerBillingCycle: 49,
                        pricePerMonth: 49
                    }
                }
            },
            medium: {
                name: 'Medium',
                size: 'M',
                amount: 500,
                price: {
                    annually: {
                        pricePerBillingCycle: 828,
                        pricePerMonth: 79
                    },
                    monthly: {
                        pricePerBillingCycle: 79,
                        pricePerMonth: 79
                    }
                }
            },
            large: {
                name: 'Large',
                size: 'L',
                amount: 1000,
                price: {
                    annually: {
                        pricePerBillingCycle: 1548,
                        pricePerMonth: 129
                    },
                    monthly: {
                        pricePerBillingCycle: 139,
                        pricePerMonth: 139
                    }
                }
            },
            'extra large': {
                name: 'Extra Large',
                size: 'XL',
                amount: 3000,
                price: {
                    annually: {
                        pricePerBillingCycle: 4188,
                        pricePerMonth: 349
                    },
                    monthly: {
                        pricePerBillingCycle: 399,
                        pricePerMonth: 399
                    }
                }
            },
            xxl: {
                name: 'XXL',
                size: 'XXL',
                amount: 5000,
                price: {
                    annually: {
                        pricePerBillingCycle: 5988,
                        pricePerMonth: 499
                    },
                    monthly: {
                        pricePerBillingCycle: 549,
                        pricePerMonth: 549
                    }
                }
            }
        };

        this.get = function () {

            return plans;
        };

        this.getCreditPlans = function () {

            // Since we remove the extra_large property on the /credits page, we return a copy of the object
            return { ...creditPlans };
        };

        this.getCreditPlanBySize = function (size) {

            for (const plan of Object.values(creditPlans)) {
                if (plan.size === size) {
                    return { ...plan };
                }
            }

            return null;
        };
    }
})();
